module.exports = __webpack_public_path__ + "img/soujiu.cde64c1a.jpg";